
import { Injectable } from '@angular/core';
import { LocalStoreManager } from './local-store-manager.service';
import { JwtHelper } from './jwt-helper';
import { ConfigurationService } from './configuration.service';

const TOKEN_KEY = 'TOKEN';
const REMEMBER_ME = 'REMEMBER_ME';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  constructor(protected localStorage: LocalStoreManager, private helper: JwtHelper, private configurationService: ConfigurationService) { }

  private static isEmptyString(value: string): boolean {
    return !value || 0 === value.length;
  }

  storeToken(token: string,) {
    if (TokenService.isEmptyString(token)) {
      throw new Error(`token can't be null or empty.`);
    }

    if (this.rememberMe()) {
      this.localStorage.savePermanentData(token, `${TOKEN_KEY}_${this.configurationService.loggingUserName}`);
    } else {
      this.localStorage.saveSessionData(token, `${TOKEN_KEY}_${this.configurationService.loggingUserName}`);
    }
  }

  deleteToken() {
    this.localStorage.deleteData(`${TOKEN_KEY}_${this.configurationService.loggingUserName}`);
    this.localStorage.deleteData(`${REMEMBER_ME}_${this.configurationService.loggingUserName}`);
  }

  getRawToken(): string {
    if (window.name && !this.configurationService.loggingUserName)
      this.configurationService.loggingUserName = window.name;
    if (this.localStorage.getData(`${TOKEN_KEY}_${this.configurationService.loggingUserName}`) && this.localStorage.getData(`${TOKEN_KEY}_${this.configurationService.loggingUserName}`)["token"])
      return this.localStorage.getData(`${TOKEN_KEY}_${this.configurationService.loggingUserName}`)["token"];
    return this.localStorage.getData(`${TOKEN_KEY}_${this.configurationService.loggingUserName}`);

  }

  getToken(): any {
    const decodedToken = this.helper.decodeToken(this.getRawToken());
    return decodedToken;
  }
  expirationDate() {
    return this.helper.getTokenExpirationDate(this.getRawToken()) as Date;
  }
  isExpired() {
    return this.helper.isTokenExpired(this.getRawToken());
  }
  rememberMe(): any {
    if (this.localStorage.getData(`${REMEMBER_ME}_${this.configurationService.loggingUserName}`) === null || this.localStorage.getData(`${REMEMBER_ME}_${this.configurationService.loggingUserName}`) === undefined)
      return false;
    return this.localStorage.getData(`${REMEMBER_ME}_${this.configurationService.loggingUserName}`);
  }

  setRememberMe(value: boolean,): void {
    this.localStorage.savePermanentData(value, `${REMEMBER_ME}_${this.configurationService.loggingUserName}`);
  }

  hasValidToken(): boolean {
    const token = this.getRawToken();
    return !TokenService.isEmptyString(token) && !this.isTokenExpired();
  }

  isTokenExpired(): boolean {
    return this.getUserId();
  }

  public getTokenExpirationTime(): Date | null {

    return this.helper.getTokenExpirationDate(this.getRawToken());
  }
  getRole() {
    return this.getToken()["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
  }
  getSerialNumber() {
    return this.getToken()["http://schemas.microsoft.com/ws/2008/06/identity/claims/serialnumber"];
  }
  getName() {
    return this.getToken()["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];
  }
  getUserId() {
    return this.getToken()["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
  }
  getIsHeadOffice() {
    return this.getToken()["IsHeadOffice"];
  }
  getDisplayName() {
    return this.getToken()["DisplayName"];
  }
  getBranchId() {
    return this.getToken()["BranchId"];
  }
}
